import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory, useParams } from 'react-router'
import NewFormWizard from '../../components/formWizard/NewFormWizard'
import Layout from '../../components/layouts/Layout'
import http from '../../config/BaseUrl'

const TextSmsEdit = () => {
    const history = useHistory()
    const {id} = useParams()
    const TextSmsEdit = history.location.state.TextMessage
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [grlErrMessage, setGrlErrorMessage] = useState("");
    const [grlCustomMessageError, setGrlCustomMessageError] = useState("");
    const {register, handleSubmit, setValue, watch, formState: { errors } } = useForm({
        mode: "all",
        reValidateMode: "onChange",
        defaultValues: {
            text_message: TextSmsEdit.text_message,
            google_review_custom_message: TextSmsEdit.google_review_custom_message || '',
            google_review_link: TextSmsEdit.google_review_link || '',
            google_review_message_delay: TextSmsEdit.google_review_message_delay || '1',
        }
    });
    const textMessage = watch("text_message");
    const textMessageCount = (textMessage || "").length;
    const googleReviewLink = watch("google_review_link");
    const googleReviewCustomMessage = watch("google_review_custom_message");
    const googleReviewCustomMessageCount = (googleReviewCustomMessage || "").length;

    const handleTextChange = (event) => {
        const value = event.target.value.slice(0, 130);
        const emojiRegex = /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu; // Regex to match a wide range of emojis

        if (!emojiRegex.test(value)) {
            setErrorMessage("");
            setValue("text_message", value);
        } else {
            setErrorMessage("");
            setValue("text_message", value);
        }
    };
    const handelSMS = async (data) => {
        const emojiRegex = /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu; // Regex to match a wide range of emojis

        if (emojiRegex.test(data.text_message)) {
            setErrorMessage("Emojis are not allowed in the text message.");
            return;
        }

        if (data.text_message && data.text_message.length > 130) {
            setErrorMessage("Text message should not exceed 130 characters.");
            return;
        }

        if (data.google_review_link && !/^https?:\/\/[^\s]+$/.test(data.google_review_link)) {
            setGrlErrorMessage("Please enter a valid URL.");
            return;
        }

        if (emojiRegex.test(data.google_review_custom_message)) {
            setGrlCustomMessageError("Emojis are not allowed in the automated follow up message.");
            return;
        }
        if (data.google_review_custom_message && data.google_review_custom_message.length > 100) {
            setGrlCustomMessageError("Automated follow up message should not exceed 100 characters.");
            return;
        }

        setErrorMessage("");
        setGrlErrorMessage("");
        setGrlCustomMessageError("");

        try {
            setLoading(true);
            await http.post(`/event/sms/update/${id}`, data).then((res) => {
                if (res) {
                    setLoading(false);
                    history.push(`/show/event/${TextSmsEdit.event_id}`, 'Information Updated.');
                }
            });
        } catch (error) {
            setLoading(false);
            console.error(error);
        }
    };

    return (
        <Layout>
            <style>
                {`
                .form-control::placeholder {
                    color: #6c757d !important;
                    opacity: 0.5 !important;
                    font-weight: 400 !important;
                }

                textarea.form-control::placeholder {
                    color: #6c757d !important;
                    opacity: 0.5 !important;
                    font-weight: 400 !important;
                }
                `}
            </style>
            <NewFormWizard />
            <section className="mt-5">
                <div className="row justify-content-center">
                    <div className="col-md-10 col-lg-8 col-xl-8">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="text-center col-12 col-md-12">
                                        <div className="pb-4">
                                            <p className="mb-0 display-4 text-primary event-form-title">Text Messaging</p>
                                            <p className="mb-0 text-secondary">SMS settings</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
               <form onSubmit={handleSubmit(handelSMS)} >
                    <div className="row justify-content-center">
                        <div className="col-md-10 col-lg-8 col-xl-8">
                            <div className="card">
                                <div className="card-body">
                                    <div className="form-group">
                                        <label className="col-form-label">Text Messaging *</label>
                                        <textarea name="" id="" cols="30" rows="2" className="form-control" {...register("text_message")} value={textMessage} onChange={handleTextChange} maxLength={130}
                                        placeholder='EG - Thank you for visiting! Special offer coming your way within 24 hours!'>
                                        </textarea>
                                        <small className="text-muted d-block text-right mt-1">
                                            {textMessageCount}/130 characters
                                        </small>
                                        <span className="text-danger font-size-14">{errors.text_message && errors.text_message.message}</span>
                                        <span className="text-danger font-size-14">{errorMessage}</span>
                                    </div>

                                    <div className='form-group row'>
                                        <div className="form-group col-md-12">
                                            <label htmlFor="">Automated Follow Up SMS Message </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="⁠Irresistible offer. EG - Spend $75, save $15 off your bill. Show the bar this SMS. Expires [date]."
                                                {...register("google_review_custom_message", { required: false })}
                                                value={googleReviewCustomMessage}
                                                maxLength={100}
                                            />
                                            <small className="text-muted d-block text-right mt-1">
                                                {googleReviewCustomMessageCount}/100 characters
                                            </small>
                                            <span className="text-danger font-size-14">{errors.google_review_custom_message && errors.google_review_custom_message.message}</span>
                                            <span className="text-danger font-size-14">{grlCustomMessageError}</span>
                                        </div>
                                    </div>

                                    <div className='form-group row'>
                                        <div className="form-group col-md-12">
                                            <label htmlFor="">What do you want guests to click on?</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Paste your link here (e.g. Google Review, booking form, or event page URL)"
                                                {...register("google_review_link", { required: false })}
                                                value={googleReviewLink}
                                            />
                                            <span className="text-danger font-size-14">{errors.google_review_link && errors.google_review_link.message}</span>
                                            <span className="text-danger font-size-14">{grlErrMessage}</span>
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="col-sm-6 col-form-label">When to Send Automated Follow Up SMS</label>
                                        <div className="col-sm-6">
                                            <select className="form-control" style={{ maxWidth: '220px' }} {...register("google_review_message_delay")}>
                                                <option value="11">11 AM</option>
                                                <option value="16">4 PM</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="col-sm-6 col-form-label">Send</label>
                                        <div className="col-sm-6">
                                            <select className="form-control" style={{ maxWidth: '220px' }} {...register("send")}>
                                                <option value="1">Social Gallery link</option>
                                            </select>
                                        </div>
                                    </div>
                                    {/* <div className="form-group row">
                                        <label className="col-sm-6 col-form-label">Country</label>
                                        <div className="col-sm-6">
                                        <select  className="form-control" {...register("country")}>
                                                {countryDialList.map((res) => {
                                                    return(
                                                        <option selected={TextSmsEdit.country === res.dialCode} value={res.dialCode} >{res.dialCode}  {res.name}</option>
                                                    )
                                                })}
                                            </select>
                                        </div>
                                    </div> */}

                                    <div className="my-5 row">
                                        <div className="col-md-12">
                                            <button type="submit" className="float-right px-5 btn btn-primary radius-30">
                                                {loading ?
                                                    <> 
                                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> 
                                                        Updating...
                                                    </>
                                                    : "Update" 
                                                }
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </form>
           </section>
        </Layout>
    )
}

export default TextSmsEdit
